module.exports = "/_next/static/images/img__form2_left_top_desktop-8d707150b5719609d1b923f5152abe2f.png";